export const removeActiveBlocks = () => {
  localStorage.removeItem('active_blocks')
}
